export const firebaseConfig = {
    apiKey: "AIzaSyA5_HzS8YzSEuDRSq056leN2KSWPS7gSKo",
    authDomain: "myroro-1fa92.firebaseapp.com",
    databaseURL: "https://myroro-1fa92.firebaseio.com",
    projectId: "myroro-1fa92",
    storageBucket: "myroro-1fa92.appspot.com",
    messagingSenderId: "488078915184",
    appId: "1:488078915184:web:b0b959662c0fae1eb326b5",
    measurementId: "G-T95J76KLB5",
}
